import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from '../../styles/ArtworkDetail.module.css';
import { getArtworkById } from '../../lib/firebase/firestore';
import { Artwork } from '../../types';

export const ArtworkDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const [artwork, setArtwork] = useState<Artwork | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArtwork = async () => {
      if (!id) return;
      const data = await getArtworkById(id);
      setArtwork(data);
      setLoading(false);
    };

    loadArtwork();
  }, [id]);

  if (loading) return <div>Loading artwork...</div>;
  if (!artwork) return <div>Artwork not found</div>;

  return (
    <div className={styles.detailContainer}>
      {/* Header */}
      <h1 className={styles.title}>{artwork.title}</h1>

      {/* Image */}
      <div className={styles.imageContainer}>
        <img src={artwork.imageUrl} alt={artwork.title} className={styles.image} />
      </div>

      {/* Description */}
      <div className={styles.description}>
        <p>{artwork.description}</p>
      </div>
    </div>
  );
};